import { TAction, TDispatch } from "../../../types";
import {
  DashboardAction,
  DashboardActionType,
  DashboardModel,
  DashboardChartDataModel,
  DashboardCountChartModel,
  DashboardFilterDataModel,
  Organization,
} from "./types";
import { fetchAPI } from "../../../../config/axios";
import { AxiosResponse } from "axios";

const defaultTingkatRisiko = {
  E: {
    total: 0,
    percentage: 0,
  },
  T: {
    total: 0,
    percentage: 0,
  },
  MT: {
    total: 0,
    percentage: 0,
  },
  M: {
    total: 0,
    percentage: 0,
  },
  RM: {
    total: 0,
    percentage: 0,
  },
  R: {
    total: 0,
    percentage: 0,
  },
};

export const DashboardDefault: DashboardModel = {
  main: {
    data: [] as any,
  },
  kriTrend: {
    data: [] as any,
  },
  rcsaProgress: {
    data: [] as any,
  },
  rcsaMonitoringProgress: {
    data: [] as any,
  },
  statusIru: {
    data: [] as any,
  },
  pemantauanIru: {
    data: [] as any,
  },
  pesebaranTingkatRisiko: {
    data: [] as any,
  },
  tingkatRisikoTarget: {
    data: defaultTingkatRisiko,
  },
  tingkatRisikoInherent: {
    data: defaultTingkatRisiko,
  },
  tingkatRisikoEksisting: {
    data: defaultTingkatRisiko,
  },
  rcsaTotalOfficer: {
    data: {} as DashboardCountChartModel,
  },
  rcsaTotalDivision: {
    data: {} as DashboardCountChartModel,
  },
  rcsaTotalRisk: {
    data: {} as DashboardCountChartModel,
  },
  /* Global Chart */
  riskByType: {
    data: {} as DashboardChartDataModel,
  },
  riskProgressWorkUnit: {
    data: {} as DashboardChartDataModel,
  },
  riskByCategory: {
    data: {} as DashboardChartDataModel,
  },
  riskMonitoringStatus: {
    data: {} as DashboardChartDataModel,
  },
  riskMonitoringMitigationStatus: {
    data: {} as DashboardChartDataModel,
  },
  /* KRI Chart */
  kriTrendList: {
    data: [] as any,
  },
  kriProgress: {
    data: [] as DashboardChartDataModel[],
  },
  iruProgress: {
    data: [] as DashboardChartDataModel[],
  },
  kriReportResult: {
    data: {} as DashboardChartDataModel,
  },
  kriMonitoringStatus: {
    data: {} as DashboardChartDataModel,
  },
  kriMonitoringMitigationStatus: {
    data: {} as DashboardChartDataModel,
  },
  /* LED Chart */
  ledTotalIncident: {
    data: {} as DashboardCountChartModel,
  },
  ledTotalActualLosses: {
    data: {} as DashboardCountChartModel,
  },
  ledProgressWorkUnit: {
    data: {} as DashboardChartDataModel,
  },
  ledProgress: {
    data: [],
  },
  ledTotalLossesPerUnit: {
    data: {} as DashboardChartDataModel,
  },
  ledTop: {
    data: [] as any,
  },
  ledMonitoringStatus: {
    data: {} as DashboardChartDataModel,
  },
  ledMonitoringMitigationStatus: {
    data: {} as DashboardChartDataModel,
  },
  /* Filter Chart */
  filterDashboard: {
    data: {} as DashboardFilterDataModel,
  },
  direktorat: {
    data: {} as Organization[],
  },
  divisi: {
    data: {} as Organization[],
  },
  departemen: {
    data: {} as Organization[],
  },
  // Skor Efektivitas
  gambaranUmum: {
    data: []
  },
  gambaranKhusus: {
    data: [],
    total: 0
  },
  gambaranKhususAllDept: {
    data: [],
    total: 0
  }
};

export const DashboardReducer = (
  state: DashboardModel = DashboardDefault,
  action: DashboardAction
): DashboardModel => {
  switch (action.type) {
    case DashboardActionType.GetDashboardChart:
      return { ...state, main: action.data };
    case DashboardActionType.GetKRITrend:
      return { ...state, kriTrend: action.data };
    case DashboardActionType.GetRiskProgress:
      return { ...state, rcsaProgress: action.data };
    case DashboardActionType.GetRcsaMonitoringProgress:
      return { ...state, rcsaMonitoringProgress: action.data };
    case DashboardActionType.GetStatusIRU:
      return { ...state, statusIru: action.data };
    case DashboardActionType.GetPemantauanIRU:
      return { ...state, pemantauanIru: action.data };
    case DashboardActionType.GetPesebaranTingkatRisiko:
      return { ...state, pesebaranTingkatRisiko: action.data };
    case DashboardActionType.GetTingkatRisikoTarget:
      return { ...state, tingkatRisikoTarget: action.data };
    case DashboardActionType.GetTingkatRisikoInherent:
      return { ...state, tingkatRisikoInherent: action.data };
    case DashboardActionType.GetTingkatRisikoEksisting:
      return { ...state, tingkatRisikoEksisting: action.data };
    case DashboardActionType.GetRiskTotalOfficer:
      return { ...state, rcsaTotalOfficer: action.data };
    case DashboardActionType.GetRiskTotalDivision:
      return { ...state, rcsaTotalDivision: action.data };
    case DashboardActionType.GetRiskTotalRisk:
      return { ...state, rcsaTotalRisk: action.data };
    /* Global Chart */
    case DashboardActionType.GetRiskByType:
      return { ...state, riskByType: action.data };
    case DashboardActionType.GetRiskProgressWorkUnit:
      return { ...state, riskProgressWorkUnit: action.data };
    case DashboardActionType.GetRiskByCategory:
      return { ...state, riskByCategory: action.data };
    case DashboardActionType.GetRiskMonitoringStatus:
      return { ...state, riskMonitoringStatus: action.data };
    case DashboardActionType.GetRiskMonitoringMitigationStatus:
      return { ...state, riskMonitoringMitigationStatus: action.data };
    /* End Global Chart */
    /* KRI Chart */
    case DashboardActionType.GetKRITrendList:
      return { ...state, kriTrendList: action.data };
    case DashboardActionType.GetKRIProgress:
      return { ...state, kriProgress: action.data };
    case DashboardActionType.GetIRUProgress:
      return { ...state, iruProgress: action.data };
    case DashboardActionType.GetKRIReportResult:
      return { ...state, kriReportResult: action.data };
    case DashboardActionType.GetKRIMonitoringStatus:
      return { ...state, kriMonitoringStatus: action.data };
    case DashboardActionType.GetKRIMonitoringMitigationStatus:
      return { ...state, kriMonitoringMitigationStatus: action.data };
    /* End KRI Chart */
    /* LED Chart */
    case DashboardActionType.GetLEDTotalIncident:
      return { ...state, ledTotalIncident: action.data };
    case DashboardActionType.GetLEDTotalActualLosses:
      return { ...state, ledTotalActualLosses: action.data };
    case DashboardActionType.GetLEDProgressWorkUnit:
      return { ...state, ledProgressWorkUnit: action.data };
    case DashboardActionType.GetLEDProgress:
      return { ...state, ledProgress: action.data };
    case DashboardActionType.GetLEDTotalLossesPerUnit:
      return { ...state, ledProgress: action.data };
    case DashboardActionType.GetTopLED:
      return { ...state, ledTop: action.data };
    case DashboardActionType.GetLEDMonitoringStatus:
      return { ...state, ledMonitoringStatus: action.data };
    case DashboardActionType.GetLEDMonitoringMitigationStatus:
      return { ...state, ledMonitoringMitigationStatus: action.data };
    /* End LED Chart */
    /* Filter Dashboard */
    case DashboardActionType.GetFilterDashboard:
      return { ...state, filterDashboard: action.data };
    case DashboardActionType.GetDirektorat:
      return { ...state, direktorat: action.data };
    case DashboardActionType.GetDivisi:
      return { ...state, divisi: action.data };
    case DashboardActionType.GetDepartemen:
      return { ...state, departemen: action.data };
    /* End Filter Dashboard */
    /* Skor Efektivitas */
    case DashboardActionType.GetGambaranUmum:
      return { ...state, gambaranUmum: action.data };
    case DashboardActionType.GetGambaranKhusus:
      return { ...state, gambaranKhusus: action.data };
    case DashboardActionType.GetGambaranKhususAllDept:
      return { ...state, gambaranKhususAllDept: action.data };
    /* End Skor Efektivitas */
    default:
      return { ...state };
  }
};

type DashboardKey =
  | "kri-trend"
  | "progres-rcsa"
  | "progres-penanganan-rcsa"
  | "status-iru"
  | "pemantauan-iru"
  | "tingkat-risiko-target"
  | "tingkat-risiko-inherent"
  | "tingkat-risiko-eksisting"
  | "pesebaran-tingkat-risiko-eksisting"
  | "risk-by-type"
  | "risk-progress-work-unit"
  | "risk-by-category"
  | "risk-total-officer"
  | "risk-total-division"
  | "risk-total"
  | "risk-monitoring-status"
  | "risk-monitoring-mitigation-status"
  | "trend-iru"
  | "progres-kri"
  | "progres-iru"
  | "kri-report-result"
  | "kri-monitoring-status"
  | "kri-monitoring-mitigation-status"
  | "led-total-incident"
  | "led-total-actual-losses"
  | "led-progress-work-unit"
  | "progres-led"
  | "led-total-losses-per-unit"
  | "led-top-led"
  | "led-monitoring-status"
  | "led-monitoring-mitigation-status"

const dashboardActionTypeMap: Record<DashboardKey, DashboardActionType> = {
  "kri-trend": DashboardActionType.GetKRITrend,
  "progres-rcsa": DashboardActionType.GetRiskProgress,
  "progres-penanganan-rcsa": DashboardActionType.GetRcsaMonitoringProgress,
  "status-iru": DashboardActionType.GetStatusIRU,
  "pemantauan-iru": DashboardActionType.GetPemantauanIRU,
  "tingkat-risiko-target": DashboardActionType.GetTingkatRisikoTarget,
  "tingkat-risiko-inherent": DashboardActionType.GetTingkatRisikoInherent,
  "tingkat-risiko-eksisting": DashboardActionType.GetTingkatRisikoEksisting,
  "pesebaran-tingkat-risiko-eksisting": DashboardActionType.GetPesebaranTingkatRisiko,
  "risk-by-type": DashboardActionType.GetRiskByType,
  "risk-progress-work-unit": DashboardActionType.GetRiskProgressWorkUnit,
  "risk-by-category": DashboardActionType.GetRiskByCategory,
  "risk-total-officer": DashboardActionType.GetRiskTotalOfficer,
  "risk-total-division": DashboardActionType.GetRiskTotalDivision,
  "risk-total": DashboardActionType.GetRiskTotalRisk,
  "risk-monitoring-status": DashboardActionType.GetRiskMonitoringStatus,
  "risk-monitoring-mitigation-status": DashboardActionType.GetRiskMonitoringMitigationStatus,
  // KRI
  "trend-iru": DashboardActionType.GetKRITrendList,
  "progres-kri": DashboardActionType.GetKRIProgress,
  "progres-iru": DashboardActionType.GetIRUProgress,
  "kri-monitoring-status": DashboardActionType.GetKRIMonitoringStatus,
  "kri-report-result": DashboardActionType.GetKRIReportResult,
  "kri-monitoring-mitigation-status": DashboardActionType.GetKRIMonitoringMitigationStatus,
  "led-total-incident": DashboardActionType.GetLEDTotalIncident,
  "led-total-actual-losses": DashboardActionType.GetLEDTotalActualLosses,
  "led-progress-work-unit": DashboardActionType.GetLEDProgressWorkUnit,
  "progres-led": DashboardActionType.GetLEDProgress,
  "led-total-losses-per-unit": DashboardActionType.GetLEDTotalLossesPerUnit,
  "led-top-led": DashboardActionType.GetTopLED,
  "led-monitoring-status": DashboardActionType.GetLEDMonitoringStatus,
  "led-monitoring-mitigation-status": DashboardActionType.GetLEDMonitoringMitigationStatus,
};

export const DashboardCommand = {
  GetDashboardChart: (params: any): TAction<DashboardAction, void> => {
    return (dispatch: TDispatch<DashboardAction>) => {
      return fetchAPI()
        .post(`/dashboard/${params.key}`, { ...params.body }, {
          params: { ...params.params }
        })
        .then((response) => {
          const type = dashboardActionTypeMap[params.key];
          if (!type) {
            throw new Error(`Unknown dashboard key: ${params.key}`);
          }
          dispatch({
            data: {
              data: response.data.data,
            },
            type,
          });
        });
    };
  },
  GetFilterDashboard: (body: unknown): TAction<DashboardAction, void> => {
    return (dispatch: TDispatch<DashboardAction>) => {
      return fetchAPI()
        .post("/dashboard/filters", { filter: body })
        .then((response) => {
          dispatch({
            data: {
              data: response.data.data,
            },
            type: DashboardActionType.GetFilterDashboard,
          });
        });
    };
  },
  GetDirektorat: (): TAction<DashboardAction, void> => {
    return async (dispatch: TDispatch<DashboardAction>) => {
      try {
        const response = await fetchAPI().get("/get-all-direktorat");
        dispatch({
          data: {
            data: response.data,
          },
          type: DashboardActionType.GetDirektorat,
        });
      } catch (err) {
        throw err;
      }
    };
  },
  GetDivisi: (): TAction<DashboardAction, void> => {
    return async (dispatch: TDispatch<DashboardAction>) => {
      try {
        const response = await fetchAPI().get("/get-all-divisi");
        dispatch({
          data: {
            data: response.data,
          },
          type: DashboardActionType.GetDivisi,
        });
      } catch (err) {
        throw err;
      }
    };
  },
  GetDepartemen: (params?: any): TAction<DashboardAction, void> => {
    return async (dispatch: TDispatch<DashboardAction>) => {
      try {
        const response = await fetchAPI().get("/get-all-departemen", params);
        dispatch({
          data: {
            data: response.data,
          },
          type: DashboardActionType.GetDepartemen,
        });
      } catch (err) {
        throw err;
      }
    };
  },
  GetGambaranUmum: (params: any): TAction<DashboardAction, void> => {
    return async (dispatch: TDispatch<DashboardAction>) => {
      try {
        const response = await fetchAPI().get("/tj-skor-efektivitas-gambaran-umum", { params });
        dispatch({
          data: {
            data: response.data?.data,
          },
          type: DashboardActionType.GetGambaranUmum,
        });
      } catch (err) {
        throw err;
      }
    };
  },
  GetGambaranKhusus: (params: any): TAction<DashboardAction, void> => {
    return async (dispatch: TDispatch<DashboardAction>) => {
      try {
        const response = await fetchAPI().get("/tj-skor-efektivitas-gambaran-khusus", { params });
        dispatch({
          data: {
            data: response.data?.data?.data,
            total: response.data?.data.total
          },
          type: DashboardActionType.GetGambaranKhusus,
        });
      } catch (err) {
        throw err;
      }
    };
  },
  GetGambaranKhususAllDept: (params: any): TAction<DashboardAction, void> => {
    return async (dispatch: TDispatch<DashboardAction>) => {
      try {
        const response = await fetchAPI().get("/tj-skor-efektivitas-gambaran-khusus/all-departemen", { params });
        dispatch({
          data: {
            data: response.data?.data?.data,
            total: response.data?.data.total
          },
          type: DashboardActionType.GetGambaranKhususAllDept,
        });
      } catch (err) {
        throw err;
      }
    };
  },
};
